<template>
	<v-row>
		<v-container fluid>
			<v-col class="d-flex child-flex" cols="10" offset="1">
				<v-img :aspect-ratio="16 / 9" src="../assets/images/intro.png" alt="img"></v-img>
			</v-col>
			<v-col cols="10" offset="1">
				<p class="text-center intro-text">{{ $t('introduction') }}</p>
			</v-col>

			<v-col cols="10" offset="1">
				<h2 class="latest-arts-title">{{ $t('latestWorks') }}</h2>
			</v-col>

			<v-col class="d-flex child-flex" cols="10" offset="1">
				<Carousel />
			</v-col>
		</v-container>

		<v-col cols="10" offset="1">
			<router-link to="/gallery">
				<h3 class="to-gallery-link">{{ $t('toGallery') }}</h3>
			</router-link>
		</v-col>
	</v-row>
</template>
<script>
import Carousel from './Carousel'

export default {
	name: 'HomeComp',
	components: { Carousel },
}
</script>

<style lang="scss" scope>
.intro-text {
	font-family: kalam;
}

.latest-arts-title {
	font-family: kalam;
}

.to-gallery-link {
	font-family: kalam;
}

a {
	text-decoration: none;
}
</style>
